import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { string, bool, shape } from 'prop-types';
import imageProps from 'TMPropTypes/imageProps';

const CoverImage = styled(GatsbyImage)`
    aspect-ratio: 1;
    width: 100%;
`;

const ImageDynamic = ({ imageData, isCover, alt, ...rest }) => {
    const gatsbyImg = getImage(imageData);
    const altText = imageData?.alt || alt;
    if (isCover) {
        return (
            <CoverImage
                alt={altText}
                image={gatsbyImg}
                placeholder="none"
                backgroundColor="transparent"
                {...rest}
            />
        );
    }
    return (
        <GatsbyImage
            placeholder="none"
            backgroundColor="transparent"
            alt={altText}
            image={gatsbyImg}
            objectPosition="left bottom"
            {...rest}
        />
    );
};

export default ImageDynamic;

ImageDynamic.propTypes = {
    imageData: shape(imageProps).isRequired,
    isCover: bool,
    alt: string
};

ImageDynamic.defaultProps = {
    isCover: false,
    alt: ''
};
